import React, { useState } from "react";
import "./styles.scss";
import { ReactComponent as TwitterIcon } from "../../../../public/icons/MenuIcons/SocialMedia/twitter.svg";
import { ReactComponent as FacebookIcon } from "../../../../public/icons/MenuIcons/SocialMedia/facebook.svg";
import { ReactComponent as LinkedinIcon } from "../../../../public/icons/MenuIcons/SocialMedia/linkedin.svg";
import { ReactComponent as CopyLinkIcon } from "../../../../public/icons/MenuIcons/SocialMedia/copy_link.svg";

import { CopyToClipboard } from "react-copy-to-clipboard";
import { Overlay } from "react-bootstrap";

import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

const submenu_social_media = [
  { id: 2, name: "twitter" },
  { id: 3, name: "facebook" },
  { id: 4, name: "linkedin" },
  { id: 5, name: "copy_link" },
];

function SocialMediaSubmenu(props) {
  const [showTextCopied, setShowTextCopied] = useState(false);

  const onSubmenuItemClick = (social) => () => {
    if (social.name === "copy_link") {
      setShowTextCopied(true);
    }
  };

  const renderSubmenuIcon = (name) => {
    let shareUrl = "";
    switch (props.type) {
      case "Post":
        shareUrl = `${window.location.host}/post/${props.object.id}`;
      case "Playlist":
      case "Podcast":
      case "Album":
        if (props.object.user && props.object.user.username) {
          shareUrl = `${window.location.host.replace("http", "https")}/${props.object.user.slug}/${props.type.toLowerCase()}s/${props.object.id}`;
        }
      case "SoundTrack":
        shareUrl = props.object.shareable_link;
    }

    switch (name) {
      case "twitter":
        return (
          <TwitterShareButton url={props.type === "SoundTrack" ? shareUrl : `https://${shareUrl}`}>
            <TwitterIcon />
          </TwitterShareButton>
        );
      case "facebook":
        return (
          <FacebookShareButton url={shareUrl}>
            <FacebookIcon />
          </FacebookShareButton>
        );
      case "linkedin":
        return (
          <LinkedinShareButton url={shareUrl}>
            <LinkedinIcon />
          </LinkedinShareButton>
        );

      case "copy_link":
        return (
          <CopyToClipboard text={shareUrl} title="Copy link">
            <CopyLinkIcon />
          </CopyToClipboard>
        );

      default:
        return;
    }
  };
  return props.socialMediaOnly ? (
    submenu_social_media.map((social) => (
      <span key={social.id} className={`${social.name}`}>
        {renderSubmenuIcon(social.name)}
      </span>
    ))
  ) : (
    <Overlay target={props.target.current} show={props.show} placement="right">
      {({ placement, arrowProps, show: _show, popper, ...props }) => (
        <div {...props} className="social-media-list-menu shared-icon">
          <div className="d-flex social-media">
            {submenu_social_media.map((social, i) => (
              <span key={social.id} className={`${social.name}`} onClick={onSubmenuItemClick(social)}>
                {renderSubmenuIcon(social.name)}
              </span>
            ))}
          </div>
          {showTextCopied && <div className="copy-section">Copied to clipboard!</div>}
        </div>
      )}
    </Overlay>
  );
}

export default SocialMediaSubmenu;
